export default "__VITE_ASSET__D_TL6w2C__"